"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.sendTractiveMetric = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _setInterval2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-interval"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var tractiveState = {
  state: 'notStarted'
};
var metricsToSend = [];
var flushMetrics = function flushMetrics() {
  (0, _forEach.default)(metricsToSend).call(metricsToSend, function (_ref) {
    var _tractiveState$track, _tractiveState;
    var billingTeam = _ref.billingTeam,
      eventName = _ref.eventName,
      customAttributes = _ref.customAttributes;
    return (_tractiveState$track = (_tractiveState = tractiveState).track) === null || _tractiveState$track === void 0 ? void 0 : _tractiveState$track.call(_tractiveState, billingTeam, eventName, customAttributes);
  });
  metricsToSend = [];
};
var loadTractive = function loadTractive() {
  if (window.tractive && window.tractive.isRunning) {
    tractiveState = {
      state: 'loaded',
      track: window.tractive.track
    };
    flushMetrics();
    return;
  }
  tractiveState = {
    state: 'loading'
  };
  var waitForTractiveLoadAttempts = 0;
  var waitForTractiveLoadIntervalId = (0, _setInterval2.default)(function () {
    if (window.tractive && window.tractive.isRunning) {
      tractiveState = {
        state: 'loaded',
        track: window.tractive.track
      };
      flushMetrics();
      clearInterval(waitForTractiveLoadIntervalId);
    } else if (waitForTractiveLoadAttempts > 30) {
      tractiveState = {
        state: 'failed'
      };
      metricsToSend = [];
      clearInterval(waitForTractiveLoadIntervalId);
    }
    waitForTractiveLoadAttempts++;
  }, 300);
};
var sendTractiveMetric = exports.sendTractiveMetric = function sendTractiveMetric(metric) {
  var _tractiveState2 = tractiveState,
    track = _tractiveState2.track,
    state = _tractiveState2.state;
  if (track) {
    var _billingTeam = metric.billingTeam,
      _eventName = metric.eventName,
      _customAttributes = metric.customAttributes;
    track(_billingTeam, _eventName, _customAttributes);
  } else if (state !== 'failed') {
    var _context;
    metricsToSend = (0, _concat.default)(_context = []).call(_context, (0, _toConsumableArray2.default)(metricsToSend), [metric]);
    if (state === 'notStarted') {
      loadTractive();
    }
  }
};
//# sourceMappingURL=tractiveService.js.map